// @flow
/** @jsx jsx */

import { useState } from 'react';

import { jsx } from '@emotion/core';
import { Button, ButtonGroup } from '@zapier/common-components';

import ZapOwnerEdit from './ZapOwnerEdit';

import type { OnSearchMembersType } from '@zapier/team/src/types';

import type { ZapTransferType } from 'app/dashboard/types';

type Props = {
  /** Call to cancel a Zap transfer */
  onCancel: () => void,
  /** Call to search account members */
  onSearchMembers: OnSearchMembersType,
  /** Call to transfer a Zap */
  onTransferZap: ZapTransferType => void,
  /** Zap to be transfered */
  zap: Object,
};

const Styles = {
  modal: {
    minHeight: '400px',
  },
};

const ZapTransfer = (props: Props) => {
  const [zap, setZap] = useState({
    ...props.zap,
    canTransfer: true,
    newOwner: {},
  });

  const handleSelectOwner = member =>
    setZap({
      ...zap,
      newOwner: member,
    });

  const canTransfer = !!zap.newOwner.id;

  return (
    <div css={Styles.modal}>
      <ZapOwnerEdit
        canTransfer={zap.canTransfer}
        newOwner={zap.newOwner}
        onSearchMembers={props.onSearchMembers}
        onSelectOwner={handleSelectOwner}
        zapTitle={zap.title}
      />
      <ButtonGroup direction="row" justify="flex-end" margin={{ top: 20 }}>
        <Button
          color="primary"
          isDisabled={!canTransfer}
          onClick={() => props.onTransferZap(zap.newOwner.id)}
        >
          Transfer Ownership
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default ZapTransfer;
